type EnumLanglage = "en" | "pl" | "de" | "es";
import sm from "./StringManager";

export interface ITextLang {
	pl: string,
	en: string,
	de: string,
	es: string,
}

export interface IStrings {
	"en": { [item: string]: string };
	"pl": { [item: string]: string };
	"de": { [item: string]: string };
	"es": { [item: string]: string };
}

export default function get(name: string, strings: IStrings): string {

	if (!strings) {
		return sm.get(name);
	}

	let lan: EnumLanglage = (window as any).qdesk?.settings?.language ?? "pl";
	let str = strings[lan][name] ?? name;
	return str;
};

export function currentLang(): EnumLanglage {
	let lang: EnumLanglage = (window as any).qdesk?.settings?.language ?? "pl";
	return lang;
}

export function select(pl: string, en: string, de: string, es: string) {
	
	let lan = (window as any).qdesk?.settings?.language as EnumLanglage ?? "pl";

	if (de && lan === "de") {
		return de;
	}

	if (es && lan === "es") {
		return es;
	}

	if (en && lan === "en") {
		return en;
	}

	return pl;
};

export function getFromText(text: ITextLang) {
	if (!text)
		return "";
	return select(text.pl, text.en, text.de, text.es);
};

export function format(format: string, args: string[], strings: IStrings) {

	return get(format, strings).replace(/{(\d+)}/g, function (match, number) {
		return typeof args[number] != 'undefined'
			? get(args[number], null)
			: match
			;
	});
}

export function selectByPrefix<T>(obj: T, prefix: keyof T): string {
	if (!obj)
		return null;
	var result = select(obj[prefix + "Pl"], obj[prefix + "En"], obj[prefix + "De"], obj[prefix + "Es"]);
	if (result)
		return result;

	return (obj[prefix])?.toString();
}